import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/AuthSlice";
import languageReducer from "./slices/LanguageSlice";
import operationReducer from "./slices/OperationSlice";
import productReducer from "./slices/ProductSlice";
import orderReducer from "./slices/OrderSlice";
import loadingReducer from "./slices/LoadingSlice";
import storeReducer from "./slices/StoreSlice";
import storeManagerReducer from "./slices/ManagerStores";
import deliveryReducer from "./slices/DeliverySlice";
import storeConfigReducer from "./slices/StoreConfigSlice";

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  reducer: {
    auth: authReducer,
    language: languageReducer,
    operation: operationReducer,
    product: productReducer,
    order: orderReducer,
    loading: loadingReducer,
    store: storeReducer,
    delivery: deliveryReducer,
    storesManager: storeManagerReducer,
    storeConfig: storeConfigReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
